import {
  useDocumentTitle,
  useDocumentTitles,
} from '@client-info/features/branding/hooks';
import Stack from '@mui/material/Stack';
import { createFileRoute } from '@tanstack/react-router';
import DefaultPolicy from './-components/DefaultPolicy/DefaultPolicy';

const CookiePolicyLayout = () => {
  useDocumentTitle(useDocumentTitles().cookies);

  return (
    <Stack component="section" id="cookie-policy-layout">
      <DefaultPolicy />
    </Stack>
  );
};

export const Route = createFileRoute('/cookies')({
  component: CookiePolicyLayout,
});
